(function () {
  'use strict';

  if (window.__noodyPdpCommerce) return;
  window.__noodyPdpCommerce = true;

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'NZD',
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }
  }

  function addBusinessDays(start, count) {
    var date = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    while (count > 0) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) count -= 1;
    }
    return date;
  }

  function deliveryText(country) {
    if (country === 'JP') return '日本への送料・配送方法はチェックアウトで表示';
    if (country !== 'NZ') return 'Tracked delivery estimate shown at checkout';
    var now = new Date();
    var options = { weekday: 'short', day: 'numeric', month: 'short' };
    var early = addBusinessDays(now, 2).toLocaleDateString('en-NZ', options);
    var late = addBusinessDays(now, 5).toLocaleDateString('en-NZ', options);
    return 'Estimated NZ delivery ' + early + '–' + late;
  }

  function track(eventName, data) {
    var payload = { event: eventName };
    Object.keys(data || {}).forEach(function (key) { payload[key] = data[key]; });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function selectedMode(root) {
    return root.querySelector('.mode.selected') || root.querySelector('.mode');
  }

  function modeUnitCents(mode, fallback) {
    var price = parseFloat(mode && mode.dataset.price);
    return isFinite(price) && price > 0 ? Math.round(price * 100) : fallback;
  }

  function discountFor(volumeRoot, quantity, subscription) {
    if (!volumeRoot || subscription) return 0;
    var two = parseFloat(volumeRoot.dataset.discountTwo) || 0;
    var three = parseFloat(volumeRoot.dataset.discountThree) || 0;
    if (quantity >= 3) return three || two;
    if (quantity >= 2) return two;
    return 0;
  }

  function openBag(feedback, navigateOnFailure) {
    var drawer = window.BWDrawer;
    if (drawer && typeof drawer.open === 'function') {
      if (typeof drawer.closePopup === 'function') drawer.closePopup(true);
      var refresh = typeof drawer.refresh === 'function' ? drawer.refresh() : null;
      Promise.resolve(refresh).then(function () { drawer.open(); }, function () { drawer.open(); });
      return;
    }

    var trigger = document.querySelector('[data-cart-drawer-toggle], header a[href$="/cart"]');
    if (trigger) trigger.click();
    else if (navigateOnFailure) window.location.href = (feedback && feedback.dataset.cartUrl) || '/cart';
  }

  function setupPurchase(root) {
    var form = root.querySelector('#bw-product-form');
    var button = root.querySelector('#mainAtc');
    var modes = Array.prototype.slice.call(root.querySelectorAll('.mode'));
    var frequency = root.querySelector('#bwFreq');
    var quantityInput = form && form.querySelector('input[name="quantity"]');
    var volumeRoot = root.querySelector('[data-ndy-bw-buybox]');
    var volume = root.querySelector('[data-ndy-multi]');
    var total = root.querySelector('[data-ndy-multi-total]');
    var note = root.querySelector('[data-ndy-multi-note]');
    var feedback = root.querySelector('[data-ndy-atc-feedback]');
    var feedbackText = feedback && feedback.querySelector('[data-ndy-atc-feedback-text]');
    var feedbackIcon = feedback && feedback.querySelector('.ndy-atc-feedback__icon');
    var viewBag = feedback && feedback.querySelector('[data-ndy-view-bag]');
    var label = button && button.querySelector('[data-ndy-atc-label]');
    var atcPrice = root.querySelector('#atcPrice');
    var stickyPrice = document.getElementById('stickyPrice');
    var afterpay = root.querySelector('#afterpayAmt');
    var baseUnit = parseInt(volumeRoot && volumeRoot.dataset.unitPrice, 10) || 0;
    var currency = (volumeRoot && volumeRoot.dataset.currency) || root.dataset.currency || 'NZD';
    var country = (volumeRoot && volumeRoot.dataset.country) || 'NZ';
    var threshold = parseInt(volumeRoot && volumeRoot.dataset.threshold, 10) || 8900;
    var busy = false;
    var resetTimer = 0;

    if (!form || !button || !quantityInput) return;

    function setMode(mode) {
      modes.forEach(function (item) {
        var active = item === mode;
        item.classList.toggle('selected', active);
        var input = item.querySelector('input[type="radio"]');
        if (input) input.checked = active;
      });
      sync();
    }

    function pricing() {
      var mode = selectedMode(root);
      var subscription = Boolean(mode && mode.dataset.plan);
      var quantity = Math.max(1, parseInt(quantityInput.value, 10) || 1);

      if (subscription && quantity !== 1) {
        quantity = 1;
        quantityInput.value = '1';
      }

      var unit = modeUnitCents(mode, baseUnit);
      var discount = discountFor(volumeRoot, quantity, subscription);
      var reference = unit * quantity;
      var finalTotal = Math.round(reference * (100 - discount) / 100);
      var standardReference = subscription ? baseUnit * quantity : reference;

      return {
        mode: mode,
        subscription: subscription,
        quantity: quantity,
        unit: unit,
        discount: discount,
        reference: reference,
        total: finalTotal,
        saving: Math.max(0, standardReference - finalTotal),
        subscriptionPercent: subscription && baseUnit ? Math.round((baseUnit - unit) * 100 / baseUnit) : 0
      };
    }

    function updateVolumeCards(state) {
      if (!volume || !volumeRoot) return;
      volume.hidden = state.subscription;
      volumeRoot.classList.toggle('is-subscription-mode', state.subscription);

      volume.querySelectorAll('[data-ndy-quantity]').forEach(function (card) {
        var quantity = parseInt(card.dataset.ndyQuantity, 10) || 1;
        var percent = discountFor(volumeRoot, quantity, false);
        var each = Math.round(baseUnit * (100 - percent) / 100);
        var badge = card.querySelector('[data-ndy-bulk-badge]');
        var eachPrice = card.querySelector('[data-ndy-each-price]');
        var active = !state.subscription && quantity === state.quantity;

        card.classList.toggle('is-active', active);
        card.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (badge) {
          badge.hidden = percent <= 0;
          badge.textContent = percent > 0 ? 'Save ' + percent + '%' : '';
        }
        if (eachPrice) {
          eachPrice.innerHTML = percent > 0
            ? '<s>' + money(baseUnit, currency) + '</s> ' + money(each, currency) + ' each'
            : money(baseUnit, currency) + ' each';
        }
      });

      if (note) {
        if (volumeRoot.dataset.giftWindow === 'true' && !state.subscription) note.textContent = volumeRoot.dataset.giftMessage;
        else if (state.subscription) note.textContent = 'Subscription pricing already includes ' + state.subscriptionPercent + '% off. Quantity offers do not stack.';
        else if (state.discount > 0) note.textContent = 'Automatic saving applied in cart — no code needed.';
        else note.textContent = (parseFloat(volumeRoot.dataset.discountTwo) || 0) > 0
          ? 'Buy 2 or 3 to unlock the automatic saving.'
          : 'Buy 3 to unlock the automatic saving.';
      }
    }

    function updateTotals(state) {
      if (atcPrice) atcPrice.textContent = money(state.total, currency);
      if (stickyPrice) stickyPrice.textContent = money(state.total, currency);
      if (afterpay) afterpay.textContent = money(Math.round(state.total / 4), currency);

      if (!total || state.subscription) return;
      var html = '';
      if (state.saving > 0) html += '<s class="ndy-bw-total__was">' + money(state.reference, currency) + '</s>';
      html += '<strong>' + money(state.total, currency) + ' total</strong>';
      if (state.saving > 0) html += '<span class="ndy-bw-total__saving">Save ' + money(state.saving, currency) + '</span>';
      if (country === 'NZ') {
        html += state.total >= threshold
          ? '<span class="is-free">Free NZ shipping</span>'
          : '<span class="ndy-bw-total__shipping">' + money(threshold - state.total, currency) + ' from free shipping</span>';
      }
      total.innerHTML = html;
    }

    function sync() {
      var mode = selectedMode(root);
      var subscription = Boolean(mode && mode.dataset.plan);

      if (frequency) {
        if (subscription) {
          var planId = mode.dataset.plan || frequency.value;
          if (planId && frequency.value !== planId) frequency.value = planId;
          frequency.disabled = false;
          mode.dataset.plan = frequency.value;
        } else {
          frequency.disabled = true;
        }
      }

      var state = pricing();
      updateVolumeCards(state);
      updateTotals(state);
      return state;
    }

    modes.forEach(function (mode) {
      var input = mode.querySelector('input[type="radio"]');
      if (input) input.addEventListener('change', function () { setMode(mode); });
      mode.addEventListener('click', function () { if (!mode.classList.contains('selected')) setMode(mode); });
    });

    if (frequency) {
      frequency.addEventListener('change', function () {
        var option = frequency.options[frequency.selectedIndex];
        var mode = frequency.closest('.mode');
        mode.dataset.plan = option.value;
        mode.dataset.price = option.dataset.price;
        var price = root.querySelector('#subPrice');
        if (price) price.textContent = money(Math.round(parseFloat(option.dataset.price) * 100), currency);
        setMode(mode);
      });
    }

    if (volume) {
      volume.addEventListener('click', function (event) {
        var card = event.target.closest('[data-ndy-quantity]');
        if (!card) return;
        quantityInput.value = card.dataset.ndyQuantity;
        var state = sync();
        track('noody_pdp_quantity_selected', {
          product_handle: root.dataset.productHandle || '',
          quantity: state.quantity,
          discount_percent: state.discount
        });
      });
    }

    var delivery = root.querySelector('[data-ndy-delivery-text]');
    if (delivery) delivery.textContent = deliveryText(country);

    function showFeedback(state, message) {
      if (!feedback) return;
      window.clearTimeout(resetTimer);
      feedback.hidden = false;
      feedback.classList.toggle('is-loading', state === 'loading');
      feedback.classList.toggle('is-success', state === 'success');
      feedback.classList.toggle('is-error', state === 'error');
      if (feedbackIcon) feedbackIcon.textContent = state === 'error' ? '!' : state === 'loading' ? '…' : '✓';
      if (feedbackText) feedbackText.textContent = message;
    }

    function setBusy(value) {
      busy = value;
      button.disabled = value;
      button.setAttribute('aria-busy', value ? 'true' : 'false');
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;

      var state = sync();
      var title = feedback && feedback.dataset.productTitle ? feedback.dataset.productTitle : 'Item';
      var endpoint = form.dataset.cartEndpoint || '/cart/add.js';
      var formData = new FormData(form);
      var planId = state.subscription && frequency ? frequency.value : '';

      if (state.subscription) {
        if (!planId) {
          showFeedback('error', 'Choose a delivery frequency before adding.');
          return;
        }
        formData.set('selling_plan', planId);
      } else {
        formData.delete('selling_plan');
      }

      setBusy(true);
      if (label) label.textContent = 'Adding…';
      showFeedback('loading', state.subscription ? 'Adding your subscription…' : 'Adding to your bag…');

      fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          if (!response.ok) throw new Error(body.description || body.message || 'That did not add. Please try again.');
          return body;
        });
      }).then(function (item) {
        var frequencyLabel = state.subscription && frequency
          ? frequency.options[frequency.selectedIndex].textContent.trim()
          : '';
        var message = state.subscription
          ? title + ' subscription added — ' + frequencyLabel.toLowerCase() + '.'
          : state.quantity > 1
            ? state.quantity + ' × ' + title + ' added to your bag.'
            : title + ' added to your bag.';

        setBusy(false);
        if (label) label.textContent = 'Added ✓';
        showFeedback('success', message);
        track('noody_pdp_add_to_cart', {
          product_handle: root.dataset.productHandle || '',
          quantity: state.quantity,
          subscription: state.subscription,
          selling_plan_id: planId,
          discount_percent: state.discount
        });
        document.dispatchEvent(new CustomEvent('bw:cart:updated'));
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { open: true, item: item } }));
        window.setTimeout(function () { openBag(feedback, false); }, 80);
        resetTimer = window.setTimeout(function () { if (label) label.textContent = 'Add to cart'; }, 1900);
      }).catch(function (error) {
        setBusy(false);
        if (label) label.textContent = 'Try again';
        showFeedback('error', error.message || 'That did not add. Please try again.');
        resetTimer = window.setTimeout(function () { if (label) label.textContent = 'Add to cart'; }, 2600);
      });
    }, true);

    if (viewBag) viewBag.addEventListener('click', function () { openBag(feedback, true); });
    sync();
  }

  function setupSticky(root) {
    var sticky = document.querySelector('[data-ndy-core-sticky]');
    var stickyButton = sticky && sticky.querySelector('[data-ndy-sticky-atc]');
    var button = root.querySelector('#mainAtc');
    var form = root.querySelector('#bw-product-form');
    if (!sticky || !stickyButton || !button || !form) return;

    sticky.setAttribute('aria-hidden', 'false');
    stickyButton.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(button);
      else button.click();
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
      observer.observe(button);
    }
  }

  function init(root) {
    if (!root || root.dataset.ndyCommerceInit === '1') return;
    root.dataset.ndyCommerceInit = '1';
    setupPurchase(root);
    setupSticky(root);
  }

  function start() {
    document.querySelectorAll('[data-ndy-core-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
